import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { HelpHomeComponent } from './help-home/help-home.component';
import { CreateTicketComponent } from './create-ticket/create-ticket.component';
import { CstmrEdittcktComponent } from './cstmr-edittckt/cstmr-edittckt.component';
import { EditTicketComponent } from './edit-ticket/edit-ticket.component';
import { HelpDocumentsComponent } from './help-documents/help-documents.component';
import { HelpFAQComponent } from './help-faq/help-faq.component';
import { HelpVediosComponent } from './help-vedios/help-vedios.component';
import { MenuListComponent } from './menu-list/menu-list.component';
import { ReleaseNoteComponent } from './release-note/release-note.component';
import { SectionsComponent } from './sections/sections.component';
import { TcktsAsgndComponent } from './tckts-asgnd/tckts-asgnd.component';
import { HelpDocsRoutingModule } from './help-docs-routing.module';
import { DxDataGridModule, DxTemplateModule } from 'devextreme-angular';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list'
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';


import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';


import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { DSCstmHdrModule } from 'app/shared/cstm-header/cstm.header.module';

@NgModule({
    declarations: [
        HelpHomeComponent,
        CreateTicketComponent,
        CstmrEdittcktComponent,
        EditTicketComponent,
        HelpDocumentsComponent,
        HelpFAQComponent,
        HelpVediosComponent,
        MenuListComponent,
        ReleaseNoteComponent,
        SectionsComponent,
        TcktsAsgndComponent,
        
       
    ],
        
    imports: [CommonModule,
      HelpDocsRoutingModule,
      DxDataGridModule,
      DxTemplateModule,
      FormsModule,
      MatTabsModule,
      MatDividerModule,
      MatFormFieldModule,
      MatInputModule,
      MatToolbarModule,
      MatIconModule,
      MatListModule,
      MatGridListModule,
      MatCardModule,
      MatSelectModule,
      MatButtonModule,
      MatOptionModule,
      DSCstmHdrModule

    ],
    exports:[

    ],
    providers: [DatePipe],
})
export class HelpDocsModule {}
